<template>
  <BreadCrumb PageTitle="État des livreurs" />
  <DriverReturnsReport />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import DriverReturnsReport from "../../components/Users/DriverReturns/DriverReturnsReport.vue";

export default defineComponent({
  name: "DriverReturnsReportPage",
  components: {
    BreadCrumb,
    DriverReturnsReport,
  },
});
</script>
